import PropTypes from 'prop-types';
import React from 'react';
import { useLocation } from 'react-router-dom';

import AppErrorBoundary from './AppErrorBoundary';

/**
 * Supplies the boundary with a value that changes on every navigation, so a
 * caught error cannot outlive the route that caused it. Kept here rather than
 * at the call site so consumers just render <AppErrorBoundary> and get the
 * reset behaviour for free — and so the class stays a plain, testable
 * component with no router dependency of its own.
 */
const AppErrorBoundaryWithLocationReset = ({ children }) => {
  const location = useLocation();

  return (
    <AppErrorBoundary resetKey={location.key ?? location.pathname}>
      {children}
    </AppErrorBoundary>
  );
};

AppErrorBoundaryWithLocationReset.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AppErrorBoundaryWithLocationReset;
